import React from 'react'
import { Component } from 'react';
import GlobalMainSearchExpertJsx from './globalMainSearchExpert.jsx'
import axios from 'axios';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import { mixPannelEvent, nameRegex, postalCodeRegex } from '../../../../shared/helper.js';
export default class GlobalMainSearchExpert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            subCategoryData: null,
            formData: {
                name: '',
                postalCode: '',
                category: null,
                subCategory: null,
                keyword: ''
            },
            oldest: false,

            selectedCategoryId: null,
            subCategories: [],
            categories: [],
            checkedCats: [],
            checkedSubCats: [],

            investmentOfferData: null,
            allOffersData: null,
            overallOffers: null,
            topOffers: null,
            mortgageOfferData: null,
            insuranceOfferData: null,
            bankingOfferData: null,
            realestateOfferData: null,
            isProcessing: false,
            formError: {},
            formSubmitButtonDisable: true,
            isLoading: false,
            selectAll: false,
            expertData: [],
            page: 1,
            totalSubCategories: "",
            disableSelectAll: true
        }
    }
    onPaginationButtonClick = (page) => {
        document.querySelector(".sortingdiv").scrollIntoView();
        this.setState({ page: page })
    }


    componentDidMount = () => {
        const mixpanelDataSearch = {
            eventName: "clicked_search_experts_preview",
            data: {
                name: "search_experts"
            }
        }
        mixPannelEvent(mixpanelDataSearch);
        const categoryIdFromPev = localStorage.getItem("selectCategory");


        this.getTopOffers();

        this.getcategorySubcategory(true);
        setTimeout(() => {
            categoryIdFromPev ? this.checkCategoryFromPrevious() : this.selectAllIds()



        }, 1000);
        this.props.match.params.keyword && this.fetchSearchData(this.props.match.params.keyword);


    }
    checkCategoryFromPrevious = () => {
        const categoryIdFromPev = localStorage.getItem("selectCategory");
        this.setState({ selectAll: false })
        if (categoryIdFromPev) {
            // Find the category in categoryData that matches the category ID 
            const selectedCategory = this.state.categoryData.find(

                category => category.institutionCategoryId.toString() === categoryIdFromPev

            );


            if (selectedCategory) {
                // Select this category and its subcategories
                this.selectCategory1(selectedCategory);
            }
        }
    }
    selectCategory1 = (selectedCategory) => {
        const institutionCategoryIds = selectedCategory.subInstitutionCategories.map(subCategory => subCategory.institutionCategoryId);

        // Add the category and its subcategories to the state
        this.setState(prevState => ({
            subCategories: [...prevState.subCategories, ...institutionCategoryIds],
            categories: [...prevState.categories, selectedCategory.institutionCategoryId]
        }));

        // Optionally trigger a filtering or update
        setTimeout(() => {
            this.filterCatData();
        }, 500);
    }

    getcategorySubcategory = (firstFetch = false) => {
        this.setState({ isLoading: true })
        let token = JSON.parse(localStorage.getItem('token'));
        axios.get(`${baseURL}/institutionCategoriesAndSubCategories`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            const enrichedData = res.data.data.map(category => ({
                ...category,
                subInstitutionCategories: category.subInstitutionCategories?.map(sub => ({
                    ...sub,
                    parentInstitutionCategoryId: category.institutionCategoryId // 👈 Add parent ref
                })) || []
            }));

            this.setState({ categoryData: enrichedData, isLoading: false });            // Calculate the total number of subInstitutionCategories
            const totalSubCategories = this.state.categoryData?.reduce((acc, category) => {
                return acc + (category.subInstitutionCategories ? category.subInstitutionCategories.length : 0);
            }, 0);

            // Set the totalSubCategories in state
            this.setState({ totalSubCategories });
        }).then(res => {
            if (firstFetch) {
                this.selectAllIds()
            }
        })
    }
    getAllFeauturedOffersData = () => {
        const selectedType = this.props.match.params.type;
        this.setState({ isProcessing: true })
        // for offer button click
        if (selectedType === "all") {
            axios.get(`${baseURL}/search-offers`).then(res => {

                this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            })
        } else if (selectedType === "homeFeatured") {

            axios.get(`${baseURL}/homeFeaturedOffers`).then(res => {

                this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            })
        } else {
            axios.get(`${baseURL}/FeaturedOffers?institutionCategoryId=${selectedType}`).then(res => {

                this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            })
        }

    }

    selectAllHit = (e) => {
        const { checked } = e.target
        if (!checked) {
            this.setState({ selectAll: false })
        } else {
            this.setState({ selectAll: true })

        }
        if (checked) {
            this.setState({ allOffersData: this.state.overallOffers, keyword: "", disableSelectAll: true })
            this.selectAllIds()


        }


    }

    searchOfferByKeyword = (e) => {
        const data = e.target.value
        this.setState({ keyword: data })
    }

    hitSearch = () => {
        this.props.history.replace('/')
        this.props.history.push(`/offers/${this.props.match.params.type}/${this.state.keyword}`)
        this.fetchSearchData(this.state.keyword)

    }

    fetchSearchData = (data) => {

        axios.get(`${baseURL}/search-content?keyword=${data}`).then(res => {
            this.setState({ allOffersData: res.data.data.offers, overallOffers: res.data.data.offers, isProcessing: false })
        })
    }

    hitOldest = (action) => {
        // this.setState(
        //     {
        //         formData: {
        //             ...this.state.formData,
        //             'name': '',
        //             'postalCode':''
        //         }
        //     }
        // )
        let { name, postalCode } = this.state.formData
        this.setState({ oldest: action, isProcessing: true, page: 1 })
        this.props.history.replace('/')
        this.props.history.push(`/globalMainSearchExpert`)
        setTimeout(() => {
            if (name || postalCode) {
                this.onSubmitButtonClick()
            } else {
                this.getTopOffers()
            }

            this.selectAllIds()
        }, 500);
    }


    getTopOffers = () => {
        const queryString = window.location.search; // Get the query string
        const urlParams = new URLSearchParams(queryString); // Create URLSearchParams object
        const searchValue = urlParams.get('search') || "";

        this.setState({ isProcessing: true })
        this.setState({ allOffersData: [], overallOffers: [] })
        axios.get(`${baseURL}/expert/search-global-experts?search=${searchValue}&page=1&perPage=100000&sortOrder=${!this.state.oldest ? "asc" : "desc"}`).then(res => {
            this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
            // Get the current URL hash
            const hash = window.location.hash;

            // Check if the desired hash link is present
            if (hash !== '') {
                // scroll to section
                const element = document.getElementById(hash.replace('#', ''));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        })
    }


    onCatgoryClick = (value) => {
        const subData = this.state.categoryData.filter(itm => itm.institutionCategoryId === Number(value))

        this.setState({ subCategoryData: subData[0]?.subInstitutionCategories })
    }
    isFromSubmissionBlock = () => {
        let { postalCode, name } = this.state.formData;

        if (postalCode || name) {
            if (this.inputRegexValidation("name", name) || this.inputRegexValidation("postalCode", postalCode)
            )
                this.setState({
                    formSubmitButtonDisable: false
                });

            else
                this.setState({
                    formSubmitButtonDisable: true
                });
        } else {
            this.setState({
                formSubmitButtonDisable: true
            });
        }
    };

    onInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (name === 'category') {
            this.onCatgoryClick(value)
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        'subCategory': '',
                    }
                }
            )

        }


        if (value) {
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            } else {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            }
        } else {
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
    }
    inputRegexValidation = (name, value) => {
        if (name === 'name')
            return nameRegex.test(value);
        if (name === 'postalCode')
            return postalCodeRegex.test(value);

        return true;
    };

    onSubmitButtonClick = () => {
        this.setState({ isProcessing: true });
        this.setState({ allOffersData: [], overallOffers: [] })
        this.setState({ page: 1 })
        const { name, postalCode } = this.state.formData;
        mixPannelEvent({
            eventName: "search_experts_query_submitted",
            data: {
                name: name,postalCode
            }
        })
        this.selectAllIds()
        axios.get(`${baseURL}/searchExperts?page=1&perPage=99999&name=${name}&postalCode=${postalCode}&sortBy=${this.state.oldest ? "desc" : "asc"}`).then(res => {
            if (res) {
                mixPannelEvent({
                    eventName: "search_results_viewed",
                    data: {
                        name: "search_results_viewed"
                    }
                })
            }
            this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })

        }).catch(err => {
            this.setState({ isProcessing: false });
            console.warn(err?.response.data.error.message);
        })
    }

    onSubmitButtonClick1 = () => {
        this.setState(
            {
                formData: {
                    ...this.state.formData,
                    'name': '',
                    'postalCode': ''
                }, page: 1
            }
        )
        // window.location.reload()
        this.selectAllIds()
        this.getTopOffers()

    }

    // filter all selected id
    selectAllIds = () => {
        localStorage.removeItem("selectCategory")

        const institutionCategoryIds = this.state.categoryData?.map(category => category.institutionCategoryId);
        this.setState({ categories: institutionCategoryIds })

        // Extract sub-institution category IDs as well
        this.state.categoryData?.forEach(category => {
            if (category?.subInstitutionCategories) {
                const subIds = category?.subInstitutionCategories?.map(subCategory => subCategory.institutionCategoryId);
                // institutionCategoryIds.push(...subIds);
                this.setState(prevState => ({
                    subCategories: [...prevState.subCategories, ...subIds] // Spread existing items and add new items
                }));
                // this.setState({ subCategories: ...subIds })

            }
        });

        this.setState({ institutionCategoryIds });
    }


    filterCatData = () => {

        const catDataFiltered = this.state.overallOffers.filter(offer => {
            return offer.expertSpecializations.some(specialization =>
                specialization.institutionCategoryId && this.state.categories.includes(specialization.institutionCategoryId)
            );
        }
        );
        this.setState({ allOffersData: catDataFiltered })
        if (this.state.subCategories.length === 0) {
            this.setState({ allOffersData: this.state.overallOffers, selectAll: true })
            this.selectAllIds()

        }


    }

    filterSubData = () => {

        const subCatDataFiltered = this.state.overallOffers.filter(offer => {
            // Check if any of the expertSpecializations have a matching institutionSubCategoryId
            return offer.expertSpecializations.some(specialization =>
                specialization.expertSpecializationSubCategories &&
                specialization.expertSpecializationSubCategories.some(subCat =>
                    this.state.subCategories.includes(subCat.institutionSubCategoryId)
                )
            );
        });


        this.setState({ allOffersData: subCatDataFiltered })
        if (this.state.subCategories.length === 0) {
            this.setState({ allOffersData: this.state.overallOffers, selectAll: true })
            this.selectAllIds()

        }

    }




    selectCategory = (data, e) => {
        const { checked } = e.target;
        const categoryId = data.institutionCategoryId;
        const subIds = data.subInstitutionCategories.map(sub => sub.institutionCategoryId);

        let updatedCategories = [...this.state.categories];
        let updatedSubCategories = [...this.state.subCategories];

        if (checked) {
            if (!updatedCategories.includes(categoryId)) updatedCategories.push(categoryId);
            subIds.forEach(subId => {
                if (!updatedSubCategories.includes(subId)) {
                    updatedSubCategories.push(subId);
                }
            });
        } else {
            updatedCategories = updatedCategories.filter(id => id !== categoryId);
            updatedSubCategories = updatedSubCategories.filter(id => !subIds.includes(id));
        }
        document.querySelector(".filtersectionglobal").scrollIntoView();

        this.setState({
            categories: updatedCategories,
            subCategories: updatedSubCategories,
            selectAll: false,
            disableSelectAll: false,
            page: 1
        }, () => {
            this.filterCatData();
            this.triggerSelectAll();
        });
    };


    handleCheckboxChange = (id) => (event) => {
        if (event.target.checked) {
            // Add ID to the selected array if not already present
            this.setState((prevState) => ({
                selectedIds: prevState.selectedIds.includes(id)
                    ? prevState.selectedIds
                    : [...prevState.selectedIds, id]
            }));
        } else {
            // Remove ID from the selected array when unchecked
            this.setState((prevState) => ({
                selectedIds: prevState.selectedIds.filter((selectedId) => selectedId !== id)
            }));
        }
    };













    selectSubCategory = (data) => {
        const subCategoryId = data.institutionCategoryId;
        const parentCategoryId = data.parentInstitutionCategoryId;

        let updatedSubCategories = [...this.state.subCategories];

        // Toggle subcategory selection
        if (updatedSubCategories.includes(subCategoryId)) {
            updatedSubCategories = updatedSubCategories.filter(id => id !== subCategoryId);
        } else {
            updatedSubCategories.push(subCategoryId);
        }

        // Find all subcategories for the parent
        const parent = this.state.categoryData.find(cat => cat.institutionCategoryId === parentCategoryId);
        const allSubIds = parent?.subInstitutionCategories.map(sub => sub.institutionCategoryId) || [];

        // Determine if all subcategories are selected
        const allSelected = allSubIds.every(id => updatedSubCategories.includes(id));

        // Determine if all subcategories are unchecked
        const noneSelected = allSubIds.every(id => !updatedSubCategories.includes(id));

        let updatedCategories = [...this.state.categories];

        // Update the parent category checkbox if all subcategories are selected
        if (allSelected) {
            // If all subcategories are selected, ensure the parent category is selected
            if (!updatedCategories.includes(parentCategoryId)) {
                updatedCategories.push(parentCategoryId);
            }
        } else if (noneSelected) {
            // If all subcategories are unchecked, unselect the parent category
            updatedCategories = updatedCategories.filter(id => id !== parentCategoryId);
        }

        this.setState({
            subCategories: updatedSubCategories,
            categories: updatedCategories,
            selectAll: false,
            disableSelectAll: false,
            page: 1
        }, () => {
            this.filterSubData();
            this.triggerSelectAll();
        });
    };


    triggerSelectAll = () => {
        setTimeout(() => {
            const uniqueData = new Set(this.state.subCategories);

            // Get the length of the unique data
            const uniqueCount = uniqueData.size;

            if (uniqueCount >= this.state.totalSubCategories) {
                this.setState({ selectAll: true })
            }
            if (uniqueCount === this.state.totalSubCategories) {
                this.setState({ disableSelectAll: true })

            }
        }, 500);

    }
    render() {
        return (
            <div>
                <GlobalMainSearchExpertJsx
                    subCategories={this.state.subCategories}
                    categories={this.state.categories}
                    searchOfferByKeyword={this.searchOfferByKeyword}
                    hitSearch={this.hitSearch}
                    selectAllHit={this.selectAllHit}
                    getAllFeauturedOffersData={this.getAllFeauturedOffersData}
                    investmentOfferData={this.state.investmentOfferData}
                    topOffers={this.state.topOffers}
                    mortgageOfferData={this.state.mortgageOfferData}
                    insuranceOfferData={this.state.insuranceOfferData}
                    bankingOfferData={this.state.bankingOfferData}
                    realestateOfferData={this.state.realestateOfferData}
                    allOffersData={this.state.allOffersData}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    page={this.state.page}
                    formSubmitButtonDisable={this.state.formSubmitButtonDisable}

                    categoryData={this.state.categoryData}
                    subCategoryData={this.state.subCategoryData}
                    formData={this.state.formData}
                    onInputChange={this.onInputChange}
                    formError={this.state.formError}
                    onSubmitButtonClick={this.onSubmitButtonClick}
                    onSubmitButtonClick1={this.onSubmitButtonClick1}
                    closFunction={this.closeFunction}
                    selectCategory={this.selectCategory}
                    selectSubCategory={this.selectSubCategory}
                    selectAll={this.state.selectAll}
                    oldest={this.state.oldest}
                    hitOldest={this.hitOldest}
                    disableSelectAll={this.state.disableSelectAll}

                />
                {this.state.isProcessing && <Loader />}

            </div>
        )
    }
}